export { SimpleTitleAndCtaRenderer } from './SimpleTitleAndCtaRenderer'
export type { SimpleTitleAndCtaRendererProps } from './SimpleTitleAndCtaRenderer'
